export default "__VITE_ASSET__676b4ded__"